import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { firebaseData } from "../../firebase";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { activeDeviceList, logoutDevice,deleteUserAccount } from "../../restApi/api";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css';
import { decrypt, decryptdata } from "../../utils/crypto";
import Modal from "react-bootstrap/Modal";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
export default function Settings(){
    const [config, setConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    const [data, setData] = useState(null);
    const [course, setCourse] = useState('');
    const [myversion, setVersion] = useState();
    const [language, setLanguage] = useState(JSON.parse(localStorage.getItem('language')));

    const [accountShow, setAccount] = useState(false);
    const [deleteAccountInfoShow, setDelete] = useState(false);
    const [reason, setReasonion] = useState('');
    const showDeleteAccount = () => setAccount(true);
    const hideAccount = () => setAccount(false);
    const continueDelete = () => setDelete(true);
    const deleteAccount = () => setDelete(false);
    let [loader,setloader]=useState(true)
    let navigate = useNavigate();


    

    const getActivityDeviceList = async() => {
        await activeDeviceList()
          .then(response => {
            return response.json()
          })
            .then(data => {
              setloader(false)
            let req= JSON.parse(decrypt(data))
            if(req.data.code==1){
                setData(req)
              }
              else if(req.data.code==402){
				authorizationCheck(navigate)
			 }
            }).catch((error) => {
              setloader(false)
          })
      }

      const mainAccountDelete = async() => {
        let d = {
            reason: reason
        }
        deleteUserAccount(d).then(response => {
            return response.json()
          })
          .then(data => {
            let req= JSON.parse(decrypt(data))
            if(req.data.code==1){
                setDelete(false);
                toast.success(req.data.message);
                navigate('/onboarding/login');
                localStorage.clear();
            }
            else if(req.data.code==402){
				authorizationCheck(navigate)
			 }
          })
      }
    
    const logout_devices = async(d) => {
        let data={
            "deviceId": d.deviceId,
            "isSelf": true,
            "isAllLogout": false,
            "userId": d.user
        }
        await logoutDevice(data)
          .then(response => {
            return response.json()
          })
          .then(data => {
            let req= JSON.parse(decrypt(data))
              if(req.data.code==1){
                toast.success(req.data.message);
                getActivityDeviceList()
              }
              else if(req.data.code==402){
				authorizationCheck(navigate)
			 }

          })
      }
      let user
      let key
      const currentlist=()=>{
          key= JSON.parse(localStorage.getItem('version'))
          setVersion(key.show)
          user= decrypt(localStorage.getItem('profileDetails'))
          user=JSON.parse(user)
          setCourse(user.preparingFor)
        
      }

      const versionSelect=(data)=>{

        localStorage.setItem('version',JSON.stringify(data))
        setVersion(data.show)
      }

      const languageSelect=(data)=>{
        localStorage.setItem('language',JSON.stringify(data))
        setLanguage(data)
      }

    useEffect(() => {
        const getConfigData = async () => {
            try {
              const remoteData = await firebaseData('settings_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
              setConfig(JSON.parse(remoteData));
              setRemoteLoading(false);
            } catch (error) {
              console.error('Error fetching remote data:', error);
              setRemoteLoading(false);
            }
          };
      
          if (typeof window !== 'undefined') {
            getConfigData();
          }
        getActivityDeviceList()
        currentlist()   
    }, []);

    const optionSelected = (dae) =>{
        setReasonion(dae)
    }

    // console.log(reason, "option Selected");

    let version=[]
    config && config?.courses?.map(o=>{
        if(o.title===course){
            version=o.versions
            return
        }
    })
    if (loader) {
        return (<><Loader/></>)
    }
    return(
        <>
        <div className="main_wrapper">
            <div className="breadcrumbs">
                <ul className="breadcrumb">
                    <li className="breadcrumb-item"><a>Home</a></li>
                    <li className="breadcrumb-item"><a>Account</a></li>
                    <li className="breadcrumb-item active"><a>Settings</a></li>
                </ul>
            </div>
            <section className="videoLayer_wrapper account_main_wrapper account_setting_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="subjects_wrapper">
                            <div className="setting_ttl_wrapper d-flex align-items-center">
                                <figure className="sett_back_arrow">
                                <Link to={'/account'}>
                                    <img src={Icons.BackArrow} alt="" className="img-fluid"/>
                                </Link>
                                </figure>
                                <div className="sett_ttl">
                                    <h5>Settings</h5>
                                </div>
                            </div>
                        </div>
                        <div className="subjects_wrapper">
                            <div className="user_info_wrappper information_options">
                                <h5>Content</h5>
                            </div>
                            <div className="setting_content_wrapper">
                                <ul type="none" className="options_child">
                                    <li>
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="active_plans">
                                                <h6>Version</h6>
                                                <p>This changes the version of video content</p>
                                            </div>
                                            <div className="arrow_plans">
                                                <div class="dropdown">
                                                    <button type="button" class="btn dropdown-toggle" data-toggle="dropdown">
                                                      {myversion}
                                                    </button>
                                                    <div class="dropdown-menu version_dropdown">
                                                    {/* <select class="dropdown-menu version_dropdown"> */}
                                                    {
                                                        version&&version.map(obj=>(
                                                        <a class="dropdown-item" href="javascript:;"  onClick={()=>versionSelect(obj)}>{obj.show}</a>
                                                        ))
                                                    }
                                                        {/* <a class="dropdown-item" href="javascript:;">V 1</a>
                                                        <a class="dropdown-item" href="javascript:;">V 3</a>
                                                        <a class="dropdown-item" href="javascript:;">V 400</a> */}
                                                    {/* </select> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="active_plans">
                                                <h6>Language</h6>
                                                <p>This toggle will select the current video language as per your choice</p>
                                            </div>
                                            <div className="arrow_plans">
                                                <span className={`english ${language==='English'?'active':''}`} onClick={()=>languageSelect('English')}>English</span>
                                                <span className={`hinglish ${language==='Hinglish'?'active':''}`} onClick={()=>languageSelect('Hinglish')}>Hinglish</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="subjects_wrapper">
                            <div className="user_info_wrappper information_options">
                                <h5>Manage Device</h5>
                            </div>
                            <div className="setting_content_wrapper manage_devices_wrapper">
                                <ul type="none" className="options_child">
                                    {
                                       data && data.data.result.numberOfDevice.map((d, i) => (
                                    <li>
                                        <div className="options_body_wrapper d-flex align-items-end">
                                            <div className="active_plans">
                                                <h6><img src={Icons.Globe} alt="globe" className="img-fluid"/> {d.deviceModelNo}</h6>
                                                <p><span></span>{d.deviceType}</p>
                                            </div>
                                            {
                                                d.deviceId===decryptdata(localStorage.getItem('dId'))&&
                                            <div className="arrow_plans">
                                                <span>Current Device</span>
                                            </div>
                                            }
                                            {
                                                d.deviceId!==decryptdata(localStorage.getItem('dId'))&&
                                            <div className="arrow_plans logout_devices">
                                                <span onClick={()=>logout_devices(d)}>
                                                    <img src={Icons.Logout} alt="Logout"  className="img-fluid"/>Log Out
                                                    <ToastContainer />
                                                </span>
                                            </div>
                                            }
                                        </div>
                                    </li>
                                        ))
                                    }
                                    {/* <li>
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="active_plans">
                                                <h6>Google Pixel</h6>
                                                <p><img src={Icons.Android} alt="android" className="img-fluid"/>Android</p>
                                            </div>
                                            <div className="arrow_plans logout_devices">
                                                <span>
                                                    <img src={Icons.Logout} alt="Logout" className="img-fluid"/>Log Out
                                                </span>
                                            </div>
                                        </div>
                                    </li> */}
                                    <li>
                                <span onClick={showDeleteAccount} style={{color:'red',cursor:'pointer'}}> <img src={Icons.Delete} alt="delete"  className="img-fluid"/>Delete Account</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12">
                        {/* <div className="videos_wrapper">
                            <div className="buy_packages d-flex align-items-center">
                                <div className="package_text">
                                    <h6>Buy Package</h6>
                                    <p>Buy Package to unlock content and Start Learning</p>
                                </div>
                                <div className="package_img">
                                    <img src={Images.Package} alt="" className="img-fluid"/>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
        </div>
        <Modal
        show={accountShow}
        onHide={hideAccount}
        backdrop="static"
        className="detail_modal report_modal"
        centered
        >
        <Modal.Header>
            <Modal.Title>
                <h4>Delete Account</h4>
                <span className="cross_icon">
                    <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideAccount}/>
                </span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="account_option_wrapper">
                <div className="account_header">
                    <h6>We're sad to see you go</h6>
                    <p>Before you go, please tell us how we can improve</p>
                </div>
                <div className="options">
                    <div className="custom-control custom-radio">
                        <input type="radio" className="custom-control-input" id="customRadio" name="example1" value="customEx" />
                        <label className="custom-control-label" for="customRadio" onClick={()=>optionSelected('Content not relevent')}>Content not relevent</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input type="radio" className="custom-control-input" id="customRadio1" name="example1" value="customEx" />
                        <label className="custom-control-label" for="customRadio1" onClick={()=>optionSelected('Course not available')}>Course not available</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input type="radio" className="custom-control-input" id="customRadio2" name="example1" value="customEx" />
                        <label className="custom-control-label" for="customRadio2" onClick={()=>optionSelected('Exam cleared')}>Exam cleared</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input type="radio" className="custom-control-input" id="customRadio3" name="example1" value="customEx" />
                        <label className="custom-control-label" for="customRadio3" onClick={()=>optionSelected('Something is broken')}>Something is broken</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input type="radio" className="custom-control-input" id="customRadio4" name="example1" value="customEx" />
                        <label className="custom-control-label" for="customRadio4" onClick={()=>optionSelected('Switching to something else')}>Switching to something else</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input type="radio" className="custom-control-input" id="customRadio5" name="example1" value="customEx" />
                        <label className="custom-control-label" for="customRadio5" onClick={()=>optionSelected(`It's too expensive`)}>It's too expensive</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input type="radio" className="custom-control-input" id="customRadio6" name="example1" value="customEx" />
                        <label className="custom-control-label" for="customRadio6" onClick={()=>optionSelected('Others')}>Others</label>
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <div className="rating_submit">
                <button type="submit" className="btn btn_theme" onClick={() => {continueDelete();hideAccount();}} disabled={reason==''? 'disabled' : ''}>Continue</button>
            </div>
        </Modal.Footer>
        </Modal>

        <Modal
        show={deleteAccountInfoShow}
        onHide={deleteAccount}
        backdrop="static"
        className="detail_modal report_modal deleteAccountInfo"
        centered
        >   
        <Modal.Header>
            <Modal.Title>
                <h4>Delete Account</h4>
                <span className="cross_icon">
                    <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={deleteAccount}/>
                </span>
            </Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <div className="account_option_wrapper">
                <div className="account_header">
                    <h6>Before continuing, please consider the following information</h6>
                    <p>The eGurukul account you are attempting to delete provides access to a wide variety of learning resources for exam preparation.The eGurukul account you are attempting to delete provides access to a wide variety of learning resources for exam preparation.The eGurukul account you are attempting to delete provides access to a wide variety of learning resources for exam preparation.</p>
                </div>
                <div className="delete_info">
                    <div className="options">
                        <h6><img src="" alt="" className="img-fluid"/> After deleting your account</h6>
                        <ul type="none">
                            <li>You'll be logged out of eGurukul & your account will no longer be usable.</li>
                            <li>Your active will be cancelled.</li>
                            <li>You'll be logged out of eGurukul & your account will no longer be usable.</li>
                            <li>Your active will be cancelled.</li>
                            <li>You'll be logged out of eGurukul & your account will no longer be usable.</li>
                            <li>Your active will be cancelled.</li>
                        </ul>
                    </div>
                    <div className="reuse_app">
                        <p>The eGurukul account you are attempting to delete provides access to a wide variety of learning resources for exam preparation.The eGurukul account you are attempting to delete provides access to a wide variety of learning resources for exam preparation.The eGurukul account you are attempting to delete provides access to a wide variety of learning resources for exam preparation.</p>
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <div className="rating_submit">
                <button type="button" className="btn btn_theme btn_border" onClick={()=>mainAccountDelete()}>Delete Account</button>
                <button type="submit" className="btn btn_theme" onClick={deleteAccount}>Cancel</button>
            </div>
        </Modal.Footer>
        </Modal>
        </>
    )
}